import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals.ts';
import { routeTree } from './routeTree.gen';
import './styles.css';
import { AuthProvider } from '@frontend/features/auth/context/AuthContext';
import { createRouter, RouterProvider } from '@tanstack/react-router';

const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

async function initializeApp() {
  const rootElement = document.getElementById('app');
  if (!rootElement || rootElement.innerHTML) {
    return;
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </StrictMode>,
  );
}

initializeApp();
reportWebVitals();
